// extracted by mini-css-extract-plugin
export default {"fs":"_3ee7266364 _2faeef9a96"};